import { createWithI18n } from '@post-office/message-maker-browser/i18n';

import { messagesLoader as rovoExpansion } from '@post-office/team-package--i18n--rovo-expansion';
import { messagesLoader as rovoChat } from '@post-office/team-package--i18n--rovo-chat';
import { messagesLoader as rovoMobile } from '@post-office/team-package--i18n--rovo-mobile';
import { type AnyProps } from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

export const withI18n: <T extends AnyProps>(component: ComponentType<T>) => ComponentType<T> =
	createWithI18n(rovoExpansion, rovoChat, rovoMobile);
